import React, { useState } from 'react'
import axios from 'axios'
import { Button, Modal, Spinner } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { teamsDisconnectUrl } from '../../smUninstallEndpoints'
import { getAxiosDefaultConfig } from 'utils'

export default function TeamsUninstallModal({ visible, closeModal, integration }) {
  const { channel } = integration || {}

  const [isProcessing, setIsProcessing] = useState(false)
  const [completed, setCompleted] = useState(false)
  const [showError, setShowError] = useState(false)

  const handleConfirm = async () => {
    setIsProcessing(true)
    setShowError(false)

    try {
      await axios.delete(teamsDisconnectUrl, getAxiosDefaultConfig())
      setCompleted(true)
      toast.success('Microsoft Teams disconnected')
    } catch (err) {
      console.error('Error disconnecting Microsoft Teams:', err)
      setShowError(true)
    } finally {
      setIsProcessing(false)
    }
  }

  const handleClose = () => {
    closeModal()
    if (completed) {
      window.location.reload()
    }
  }

  return (
    <Modal show={visible} onHide={handleClose}>
      <Modal.Body>
        <div className="tw-p-6">
          <h2 className="tw-text-xl tw-mb-6">Disconnect {channel}</h2>
          {showError && (
            <p className="tw-text-red-600 tw-mb-4">Error disconnecting integration. Please try again.</p>
          )}
          <p className="tw-mb-4">
            {completed ? (
              `${channel} has been disconnected.`
            ) : (
              <>
                This removes your PayHelm Teams connection and the account links for your teammates.
                {' '}
                To stop the bot from appearing in Teams entirely, also remove the PayHelm app from your
                Microsoft Teams tenant.
              </>
            )}
          </p>
          <div className="tw-flex tw-justify-end tw-space-x-2">
            <Button variant="secondary" size="sm" onClick={handleClose}>
              {completed ? 'Done' : 'Cancel'}
            </Button>
            {!completed && (
              <Button variant="danger" size="sm" onClick={handleConfirm} disabled={isProcessing}>
                {isProcessing ? (
                  <>
                    <Spinner animation="border" size="sm" className="tw-mr-2" />
                    Disconnecting...
                  </>
                ) : (
                  'Disconnect'
                )}
              </Button>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}
